import { AliasToken } from 'antd/es/theme/interface'
import darkColors1ppon from '../../1ppon/ippon-dark-colors.module.scss'
import lightColors1ppon from '../../1ppon/ippon-light-colors.module.scss'
import { ComponentsToken } from 'antd/lib/theme/context'
import { convertPxToNumber } from '../../../utils/helpers.ts'

export const getDarkToken1ppon = (): Partial<AliasToken> => {
  return {
    fontFamily: 'FigTree',

    colorPrimary: darkColors1ppon.blue6,
    colorPrimaryBg: '#1C5B7D',
    colorPrimaryBgHover: darkColors1ppon.blue7,
    colorPrimaryBorder: darkColors1ppon.blue8,
    colorPrimaryBorderHover: darkColors1ppon.blue7,
    colorPrimaryHover: darkColors1ppon.blue9,
    colorPrimaryActive: darkColors1ppon.blue5,
    colorPrimaryTextHover: darkColors1ppon.blue10,
    colorPrimaryText: darkColors1ppon.blue10,
    colorPrimaryTextActive: darkColors1ppon.blue5,

    blue1: darkColors1ppon.blue1,
    blue2: darkColors1ppon.blue2,
    blue3: darkColors1ppon.blue3,
    blue4: darkColors1ppon.blue4,
    blue5: darkColors1ppon.blue5,
    blue6: darkColors1ppon.blue6,
    blue7: darkColors1ppon.blue7,
    blue8: darkColors1ppon.blue8,
    blue9: darkColors1ppon.blue9,
    blue10: darkColors1ppon.blue10,

    yellow1: darkColors1ppon.yellow1,
    yellow2: darkColors1ppon.yellow2,
    yellow3: darkColors1ppon.yellow3,
    yellow4: darkColors1ppon.yellow4,
    yellow5: darkColors1ppon.yellow5,
    yellow6: darkColors1ppon.yellow6,
    yellow7: darkColors1ppon.yellow7,
    yellow8: darkColors1ppon.yellow8,
    yellow9: darkColors1ppon.yellow9,
    yellow10: darkColors1ppon.yellow10,

    paddingMD: 16,
  }
}

export const getDarkComponents = (): Partial<ComponentsToken> => {
  return {
    Button: {
      defaultBg: darkColors1ppon.blue6,
      defaultHoverBg: darkColors1ppon.btnBgHover,
      defaultActiveBg: darkColors1ppon.blue5,
      colorBgContainerDisabled: darkColors1ppon.btnBgDisable,
      colorBorder: darkColors1ppon.blue8,
      colorText: darkColors1ppon.btnTextText,
      colorError: darkColors1ppon.btnDangerBg,
      colorErrorBgHover: darkColors1ppon.btnDangerBgHover,
      colorErrorText: '#FFFFFF',
      primaryColor: '#FFFFFF',
      borderColorDisabled: darkColors1ppon.colorBorder,
    },
    Checkbox: {
      colorText: darkColors1ppon.checkBoxText,
    },
    Switch: {
      colorPrimary: darkColors1ppon.switchBg,
      colorPrimaryHover: darkColors1ppon.switchBg,
    },
    Menu: {
      itemBg: darkColors1ppon.naviBgPrimary,
      subMenuItemBg: darkColors1ppon.naviBgSecondary,
      itemSelectedBg: darkColors1ppon.naviBtnFocused,
      itemSelectedColor: darkColors1ppon.naviText,
      colorText: darkColors1ppon.naviText,
      popupBg: darkColors1ppon.blue7,
      subMenuItemSelectedColor: darkColors1ppon.naviText,
    },
    Layout: {
      headerBg: darkColors1ppon.naviBgPrimary,
      siderBg: darkColors1ppon.naviBgPrimary,
      footerBg: darkColors1ppon.footerBg,
    },
    Segmented: {
      trackBg: darkColors1ppon.colorBorder,
    },
    Form: {
      itemMarginBottom: convertPxToNumber(darkColors1ppon.marginBase),
    },
    Radio: {
      colorPrimary: darkColors1ppon.blue8,
      colorBgContainer: '#1C1C1C',
    },
    Tabs: {
      itemSelectedColor: darkColors1ppon.blue8,
      inkBarColor: darkColors1ppon.blue8,
    },
    Drawer: {
      colorBgElevated: darkColors1ppon.naviBgPrimary,
    },
  }
}

export const getDarkComponents1ppon = (): Partial<ComponentsToken> => {
  return {
    Button: {
      defaultBg: darkColors1ppon.colorPrimary,
      defaultHoverBg: darkColors1ppon.btnBgHover,
      defaultActiveBg: darkColors1ppon.colorPrimaryActive,
      colorBgContainerDisabled: darkColors1ppon.colorBgContainerDisabled,
      colorBorder: darkColors1ppon.colorPrimaryBorder,
      colorText: darkColors1ppon.btnTextText,
      colorError: darkColors1ppon.btnDangerBg,
      colorErrorBgHover: darkColors1ppon.btnDangerBgHover,
      colorErrorText: '#FFFFFF',

      groupBorderColor: darkColors1ppon.colorPrimaryHover,
      defaultHoverColor: darkColors1ppon.colorPrimaryHover,
      defaultHoverBorderColor: darkColors1ppon.colorPrimaryHover,
      defaultActiveColor: darkColors1ppon.colorPrimaryActive,
      defaultActiveBorderColor: darkColors1ppon.colorPrimaryActive,
    },
    Checkbox: {
      colorPrimaryHover: darkColors1ppon.colorPrimaryHover,
      colorPrimaryBorder: darkColors1ppon.colorPrimaryBorder,
      colorPrimary: darkColors1ppon.colorPrimary,
    },
    Switch: {
      colorPrimary: darkColors1ppon.colorPrimary,
      colorPrimaryHover: darkColors1ppon.colorPrimaryHover,
    },
    Menu: {
      itemBg: darkColors1ppon.naviBgPrimary,
      subMenuItemBg: darkColors1ppon.naviBgSecondary,
      itemHoverBg: darkColors1ppon.colorPrimaryBgHover,
      itemSelectedBg: darkColors1ppon.naviBtnFocused,
      itemSelectedColor: darkColors1ppon.naviText,
      colorText: darkColors1ppon.naviText,
      subMenuItemSelectedColor: darkColors1ppon.naviText,
    },
    Layout: {
      headerBg: darkColors1ppon.naviBgPrimary,
      siderBg: darkColors1ppon.naviBgPrimary,
      footerBg: darkColors1ppon.footerBg,
    },
    Segmented: {
      trackBg: '#424242',
      itemSelectedBg: '#1b204f',
    },
    Form: {
      itemMarginBottom: convertPxToNumber(darkColors1ppon.marginBase),
    },
    Radio: {
      colorPrimary: darkColors1ppon.blue8,
      colorBgContainer: '#FFFFFF',
    },
    Tabs: {
      itemSelectedColor: darkColors1ppon.blue8,
      inkBarColor: darkColors1ppon.blue8,
    },
    Drawer: {
      colorBgElevated: darkColors1ppon.naviBgPrimary,
    },
  }
}

export const getLightComponents1ppon = (): Partial<ComponentsToken> => {
  return {
    Button: {
      defaultBg: lightColors1ppon.colorPrimary,
      defaultHoverBg: lightColors1ppon.btnBgHover,
      defaultActiveBg: lightColors1ppon.colorPrimaryActive,
      colorBgContainerDisabled: lightColors1ppon.colorBgContainerDisabled,
      colorBorder: lightColors1ppon.colorPrimaryBorder,
      colorText: lightColors1ppon.btnTextText,
      colorError: lightColors1ppon.btnDangerBg,
      colorErrorBgHover: lightColors1ppon.btnDangerBgHover,
      colorErrorText: '#FFFFFF',

      groupBorderColor: lightColors1ppon.colorPrimaryHover,
      defaultHoverColor: lightColors1ppon.colorPrimaryHover,
      defaultHoverBorderColor: lightColors1ppon.colorPrimaryHover,
      defaultActiveColor: lightColors1ppon.colorPrimaryActive,
      defaultActiveBorderColor: lightColors1ppon.colorPrimaryActive,
    },
    Checkbox: {
      colorPrimaryHover: lightColors1ppon.colorPrimaryHover,
      colorPrimaryBorder: lightColors1ppon.colorPrimaryBorder,
      colorPrimary: lightColors1ppon.colorPrimary,
    },
    Switch: {
      colorPrimary: lightColors1ppon.colorPrimary,
      colorPrimaryHover: lightColors1ppon.colorPrimaryHover,
    },
    Menu: {
      itemBg: lightColors1ppon.naviBgPrimary,
      subMenuItemBg: lightColors1ppon.naviBgSecondary,
      itemHoverBg: lightColors1ppon.colorPrimaryBgHover,
      itemSelectedBg: lightColors1ppon.naviBtnFocused,
      itemSelectedColor: lightColors1ppon.naviText,
      colorText: lightColors1ppon.naviText,
      subMenuItemSelectedColor: lightColors1ppon.naviText,
    },
    Layout: {
      headerBg: lightColors1ppon.naviBgPrimary,
      siderBg: lightColors1ppon.naviBgPrimary,
      footerBg: lightColors1ppon.footerBg,
    },
    Segmented: {
      trackBg: 'rgba(217, 217, 217, 1)',
    },
    Form: {
      itemMarginBottom: convertPxToNumber(lightColors1ppon.marginBase),
    },
    Radio: {
      colorPrimary: lightColors1ppon.blue8,
      colorBgContainer: '#FFFFFF',
    },
    Tabs: {
      itemSelectedColor: lightColors1ppon.blue8,
      inkBarColor: lightColors1ppon.blue8,
    },
    Drawer: {
      colorBgElevated: lightColors1ppon.naviBgPrimary,
    },
  }
}

export const getLightToken1ppon = (): Partial<AliasToken> => {
  return {
    fontFamily: 'FigTree',

    colorPrimary: lightColors1ppon.green5,
    colorPrimaryBg: lightColors1ppon.green1,
    colorPrimaryBgHover: lightColors1ppon.green1,
    colorPrimaryBorder: lightColors1ppon.green2,
    colorPrimaryBorderHover: lightColors1ppon.green3,
    colorPrimaryHover: lightColors1ppon.green4,
    colorPrimaryActive: lightColors1ppon.green6,
    colorPrimaryTextHover: lightColors1ppon.green4,
    colorPrimaryText: lightColors1ppon.green5,
    colorPrimaryTextActive: lightColors1ppon.green6,
    controlOutline: lightColors1ppon.controlOutline,

    colorLinkHover: lightColors1ppon.violet5,
    colorLinkActive: lightColors1ppon.violet7,
    colorLink: lightColors1ppon.violet6,

    green1: lightColors1ppon.green1,
    green2: lightColors1ppon.green2,
    green3: lightColors1ppon.green3,
    green4: lightColors1ppon.green4,
    green5: lightColors1ppon.green5,
    green6: lightColors1ppon.green6,
    green7: lightColors1ppon.green7,
    green8: lightColors1ppon.green8,
    green9: lightColors1ppon.green9,
    green10: lightColors1ppon.green10,

    magenta1: lightColors1ppon.violet1,
    magenta2: lightColors1ppon.violet2,
    magenta3: lightColors1ppon.violet3,
    magenta4: lightColors1ppon.violet4,
    magenta5: lightColors1ppon.violet5,
    magenta6: lightColors1ppon.violet6,
    magenta7: lightColors1ppon.violet7,
    magenta8: lightColors1ppon.violet8,
    magenta9: lightColors1ppon.violet9,
    magenta10: lightColors1ppon.violet10,

    paddingMD: 16,
  }
}
